import { useEffect, useState } from "react";
import { api, money } from "../../lib/api";
import { PageHeader } from "../../components/admin/ui";

export default function Customers() {
  const [data, setData] = useState({ customers: [], accounts: 0 });
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    api.get("/admin/customers").then((r) => setData(r.data));
    api.get("/admin/newsletter").then((r) => setSubs(r.data));
  }, []);
  return (
    <div data-testid="admin-customers">
      <PageHeader title="العملاء" desc={`${data.customers.length} عميلة طلبن من المتجر · ${data.accounts} حساب مسجل`} />
      <div className="overflow-x-auto rounded-md border border-gray-200 bg-white">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500"><tr className="text-right"><th className="p-3">الاسم</th><th>الجوال</th><th>البريد</th><th>المدينة</th><th>الطلبات</th><th>إجمالي المشتريات</th><th>آخر طلب</th></tr></thead>
          <tbody>
            {data.customers.map((c) => (
              <tr key={c.phone} className="border-t border-gray-100">
                <td className="p-3 font-medium">{c.name}</td><td dir="ltr" className="text-right">{c.phone}</td><td className="text-xs">{c.email || "—"}</td>
                <td>{c.city}</td><td>{c.orders}</td><td>{money(c.spent)} ر.س</td><td className="text-xs">{new Date(c.last_order).toLocaleDateString("ar-SA")}</td>
              </tr>
            ))}
            {!data.customers.length && <tr><td colSpan={7} className="p-10 text-center text-gray-500">لا يوجد عملاء بعد</td></tr>}
          </tbody>
        </table>
      </div>
      <h2 className="mb-3 mt-8 font-bold">المشتركات في القائمة البريدية ({subs.length})</h2>
      <div className="rounded-md border border-gray-200 bg-white p-4 text-sm" dir="ltr">
        {subs.length ? subs.map((s) => <div key={s.email} className="py-1">{s.email}</div>) : <span className="text-gray-500">—</span>}
      </div>
    </div>
  );
}
